<template>
	<div id="graph" style="width:100%; height:calc(100vh - 60px);">

		<chart
		v-for="(value, index) in values"
		:id="'chart_'+index+'_'+term"
		:width="width*tableSettings[index].width"
		:height="height*tableSettings[index].height"
		:values="values[index]"
		:settings="tableSettings[index]"
		class="chart"
		:style="{top:(height*tableSettings[index].y+50)+'px',left:(width*tableSettings[index].x)+'px'}"
		:key="'graph_'+index+'_'+updateKey">
		</chart>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.DASHBOARD_PAGE,
			width:0,
			height:0,
			updateKey:0,

			tableSettings:[],
			values:[],

			refresh:[],
		}
	},
	created(){
		this.getGraphData();
	},
	methods: {
		onResize(){
			this.width = parseInt(document.getElementById("graph").offsetWidth)-5;
			this.height = parseInt(document.getElementById("graph").offsetHeight)-5;

			this.updateKey++;
		},
		setRefresh(chartId,rate){
			if(this.refresh[chartId]!=null){
				clearInterval(this.refresh[chartId]);
				this.refresh[chartId] = null;
			}

			if(rate>0){
				this.refresh[chartId] = setInterval(() => {
					this.getGraphData(chartId);
				}, rate*1000);
			}
		},
		getGraphData(chartId=-1){
			api.postData(
				{
					type:"search",
					data:{
						pageid:this.pageid,
						data:[
							this.term,
							chartId
						]
					}
				}
			).then((res) => {
				if(chartId==-1){
					this.values = [];
					this.tableSettings = [];
				}
				for(let r = 0;r<res.data.length;r++){
					var v = 0;

					if(chartId==-1){
						 this.values.push([]);
						 this.tableSettings.push({});
 						 v = this.values.length-1;
					}else{
						v = chartId;
						this.values[v] = [];
						this.tableSettings[v] = {};
					}

					let datasetVal = [];
					let colors = res.data[r].colordata.data.column_data;
					let data = res.data[r].data.data.column_data[0];
					let querydata = res.data[r].querydata.data.column_data;
					let querynames = res.data[r].querydata.data.column_names;
					let dashdata = res.data[r].dashdata;

					this.tableSettings[v].type = data[2];
					this.tableSettings[v].title = data[3];
					this.tableSettings[v].labelX=dashdata[8];
					this.tableSettings[v].labelY=dashdata[9];
					this.tableSettings[v].x=parseFloat(dashdata[1])/100;
					this.tableSettings[v].y=parseFloat(dashdata[2])/100;
					this.tableSettings[v].width=parseFloat(dashdata[3])/100;
					this.tableSettings[v].height=parseFloat(dashdata[4])/100;

					this.tableSettings[v].fonts = {};
					this.tableSettings[v].fonts.title = parseFloat(dashdata[11]);
					this.tableSettings[v].fonts.axis = parseFloat(dashdata[12]);
					this.tableSettings[v].fonts.scale = parseFloat(dashdata[13]);
					this.tableSettings[v].fonts.value = parseFloat(dashdata[14]);
					this.tableSettings[v].fonts.legend = parseFloat(dashdata[15]);

					this.tableSettings[v].colors = {};
					this.tableSettings[v].colors.frame = dashdata[5];
					this.tableSettings[v].colors.table = dashdata[6];
					this.tableSettings[v].colors.background = dashdata[7];

					if(data[2] == "table"){
						this.values[v]={column_names:querynames,column_data:querydata};
					}else{
						let labels = [];
						for(let i = 0;i<querydata.length;i++){
							if(!labels.includes(querydata[i][2])){
								labels.push(querydata[i][2]);
							}
						}

						for(let i = 0;i<querydata.length;i++){
							if(this.datasetContains(datasetVal,querydata[i][0])==-1){
								datasetVal.push(querydata[i][0])
								this.values[v].push({coords:[],color:"#000000"});
							}
							let pos = this.datasetContains(datasetVal,querydata[i][0]);

							let value = labels.indexOf(querydata[i][2])
							if(value==-1){
								alert(i)
							}

							this.values[v][pos].coords.push([value,parseFloat(querydata[i][3])])
							this.values[v][pos].color = colors[pos][0]
							this.values[v][pos].label = querydata[i][0]
						}

						var minY = parseFloat(querydata[0][3]);
						var maxY = parseFloat(querydata[0][3]);
						for(let i = 1;i<querydata.length;i++){
							if(parseFloat(querydata[i][3])>maxY){
								maxY=parseFloat(querydata[i][3]);
							}
							if(parseFloat(querydata[i][3])<minY){
								minY=parseFloat(querydata[i][3]);
							}
						}

						if(this.tableSettings[v].type == 'stacked'){
							for(let i = 0;i<this.values[v].length;i++){
								for(let j = 0;j<labels.length;j++){
									if((this.values[v][i].coords[j]==null || this.values[v][i].coords[j][0]!=j)){
										this.values[v][i].coords.splice(j,0,[j,0]);
									}
								}
							}

							var maxYList = [];
							for(let i = 0;i<this.values[v][0].coords.length;i++){
								maxYList.push(0);
							}
							for(let i = 0;i<this.values[v].length;i++){
								for(let j = 0;j<this.values[v][i].coords.length;j++){
									maxYList[j]+=this.values[v][i].coords[j][1];
								}
							}
							var maxId = 0;
							for(let i = 1;i<maxYList.length;i++){
								if(maxYList[i]>maxYList[maxId]){
									maxId = i;
								}
							}
							maxY = maxYList[maxId];
						}

						var a = parseInt((maxY-minY).toExponential().split('e')[1]);
						var b = parseInt(Math.ceil(maxY/10**a));
						var c = parseInt(Math.floor(minY/10**a));
						var d = parseInt((c<1&&c>=0)?0:c-1);
						var e = b+1;
						var f = e-d;
						var g = 10;
						if(f>3){
							g=f;
						}else if(f==3){
							g=6;
						}else if(f==2){
							g=8;
						}else if(f==1){
							g=5;
						}

						var rMinY = d*10**a;
						var rMaxY = e*10**a;
						var div = g;

						this.tableSettings[v].minValueX = 0;
						this.tableSettings[v].maxValueX = labels.length-1;
						this.tableSettings[v].intervalsX=0;
						this.tableSettings[v].labeledIntervalsX=6;

						this.tableSettings[v].minValueY = rMinY;
						this.tableSettings[v].maxValueY = rMaxY;
						this.tableSettings[v].intervalsY=div;
						this.tableSettings[v].labeledIntervalsY=div;

						this.tableSettings[v].labels = labels;
					}

					this.setRefresh(v, parseFloat(dashdata[10]));
				}
				this.updateKey++;
			});
		},
		datasetContains(dataset,value){
			for(let i = 0;i<dataset.length;i++){
				if(dataset[i]==value){
					return i;
				}
			}
			return -1;
		},
	},
	mounted () {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		})
		this.onResize();
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	watch:{
		term(){
			this.getGraphData();
		},
	}
}
</script>

<style>

.chart{
	position:fixed;
}

</style>



// WEBPACK FOOTER //
// src/components/view/Graphs.vue